// @mui
import PropTypes from 'prop-types';
import { useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import {
  Card,
  Dialog,
  CardHeader,
  CardContent,
  Box,
  Unstable_Grid2 as Grid,
  Divider,
  CardActions,
  TextField,
  Button,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  FormHelperText,
} from '@mui/material';
import { roomModelSchema } from '../../../schemas';
import { setOpenModel } from '../../../features/model/modelSlice';
import { toTitleCase } from '../../../utils/formatText';

RoomModel.propTypes = {
  actionType: PropTypes.string.isRequired,
  // currentRoom: PropTypes.oneOfType([null, PropTypes.object])
};

function RoomModel({ actionType, currentRoom }) {
  const roomType = [
    {
      id: 1,
      roomType: 'royal suite',
    },
    {
      id: 2,
      roomType: 'super deluxe',
    },
    {
      id: 3,
      roomType: 'deluxe',
    },
  ];
  const { modelOpen } = useSelector((state) => state.setModel);

  const dispatch = useDispatch();
  const [room, setRoom] = useState({
    description: '',
    roomType: '',
    name: '',
    capacity: '',
    price: '',
  });

  const { values, errors, handleBlur, handleChange, touched } = useFormik({
    enableReinitialize: true,
    initialValues: room,
    validationSchema: roomModelSchema,
    onSubmit: (value, action) => {
      action.resetForm();
    },
  });

  const handleModelClose = () => dispatch(setOpenModel(false));

  return (
    <Dialog open={modelOpen} onClose={handleModelClose}>
      <form autoComplete="on">
        <Card>
          <CardHeader subheader="The information can be edited" title={`${actionType} Room`} />
          <CardContent>
            <Box>
              <Grid container spacing={3}>
                <Grid xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="roomTypeLabel">Room Type</InputLabel>
                    <Select
                      labelId="roomTypeLabel"
                      id="roomType"
                      name="roomType"
                      value={values.roomType}
                      label="Room Type"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.roomType && errors.roomType)}
                    >
                      {roomType &&
                        roomType.map((roomDetail) => (
                          <MenuItem
                            style={{ textTransform: 'capitalize' }}
                            key={roomDetail.id}
                            value={roomDetail.roomType}
                          >
                            {toTitleCase(roomDetail.roomType)}
                          </MenuItem>
                        ))}
                    </Select>
                    {touched.roomType && errors.roomType ? (
                      <FormHelperText sx={{ color: '#bf3333', marginLeft: '16px !important' }}>
                        {touched.roomType && errors.roomType}
                      </FormHelperText>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Room Name"
                    helperText={errors.name && touched.name ? errors.name : null}
                    id="name"
                    name="name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                  />
                </Grid>
                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Price"
                    id="price"
                    name="price"
                    helperText={errors.price && touched.price ? errors.price : null}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.price}
                  />
                </Grid>
                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Capacity(Max No. of Person)"
                    id="capacity"
                    name="capacity"
                    helperText={errors.capacity && touched.capacity ? errors.capacity : null}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.capacity}
                  />
                </Grid>

                <Grid xs={12} md={12}>
                  <TextField
                    fullWidth
                    label="Small Information(Optional)"
                    id="description"
                    helperText={errors.description && touched.description ? errors.description : null}
                    name="description"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.description}
                    multiline
                    rows={3}
                  />
                </Grid>
              </Grid>
            </Box>
          </CardContent>
          <Divider />
          <CardActions sx={{ justifyContent: 'flex-end' }}>
            <Button variant="contained" onClick={handleModelClose}>
              {`${actionType} Room`}
            </Button>
            <Button variant="contained" onClick={handleModelClose}>
              Cancel
            </Button>
          </CardActions>
        </Card>
      </form>
    </Dialog>
  );
}

export default memo(RoomModel);
